import { useSyncExternalStore } from 'react';
import { useDarkModeStore } from '@/client/hooks/useDarkModeStore';
export function useDarkMode() {
  "use memo";

  const {
    subscribe,
    snapshot
  } = useDarkModeStore();
  return useSyncExternalStore(subscribe, snapshot, _temp);
}
function _temp() {
  return false;
}